// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 60868 ? "auth-suite-sdk" : chunkId) + "-" + {"12322":"535376788b7e81746476","16342":"bd6ee8e4f19db13b4474","22242":"311947b2c5f870582092","25538":"69f409edbac95642d391","44139":"1f10d6095dcca8e844e5","60868":"e7f150791f18db8a68df","78473":"79fdddab2168628d7564"}[chunkId] + ".min.js";
};